import React from "react";

interface PercentileCircleProps {
    value: number;
    size?: number;
    strokeWidth?: number;
}

const PercentileCircle: React.FC<PercentileCircleProps> = ({ value, size = 44, strokeWidth = 5 }) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const percent = Math.max(0, Math.min(100, value));
    const offset = circumference * (1 - percent / 100);

    return (
        <div style={{ position: "relative", width: size, height: size, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <svg width={size} height={size}>
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke="#e5eaf2"
                    strokeWidth={strokeWidth}
                    fill="white"
                />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke="#176AFF"
                    strokeWidth={strokeWidth}
                    fill="none"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    style={{ transition: "stroke-dashoffset 0.4s" }}
                />
            </svg>
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: size,
                    height: size,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 400,
                    color: "#000000ff",
                    fontSize: size * 0.30,
                    background: "transparent",
                }}
            >
                {percent}%
            </div>
        </div>
    );
};

export default PercentileCircle;
